import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { dateToString } from "~/utils/formatter";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import { useForm } from "react-hook-form";
import useAlert from "~/common/hooks/useAlert";

// Assets
import "../../../assets/sass/pages/apply/applyManage.scss";
import "../../../assets/sass/pages/apply/applyList.scss";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";

//pages
import { CautionIcon } from "~/assets/svg/InterfaceIcon";
import ApplyMangeListTable from "./applyMangeListTable";
import ApplyDetailModal from "./Modal/ApplyDetailModal";
import ApplyItemSetting from "./Modal/ApplyItemSetting";
import JudgeListModal from "./Modal/JudgeListModal";
import JudgeParticipants from "./Modal/JudgeParticipants";
import JudgeResultModal from "./Modal/JudgeResultModal";
import { useTranslation } from "react-i18next";
import TabMenu from "~/common/components/TabMenu";
import LoadingPage from "~/pages/LoadingPage";
import { Case, If, OtherWise } from "~/common/components/If";
import Form, { Group } from "~/common/components/Form";
import DatePicker from "~/common/components/DatePicker";
import Input from "~/common/components/Input";
import Radio from "~/common/components/Radio";
import Pagination from "~/common/components/Pagination";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import Processing from "~/pages/investment/InvestSettingPage/processingModal/Processing";




const ApplyManage = () => {
	const { t } = useTranslation();
	const applyListForm = useForm({
		defaultValues: {
			dateType: "1",
			createdFrom: new Date(null),
			createdTo: new Date(),
		},
	});
	const containerRef = useRef();

	const [searchElement, setSearchElement] = useState({});
	const listRequest = useRequest("post", "vc/apply/search");
	const searchRequest = useRequest("post", "vc/apply/search");
	const [loadingPage, setLoadingPage] = useState(false);

	const [formData, setFormData] = useState({
		industryFields: [],
		investLevels: [],
		page: 1,
		size: 10,
		companyName: "",
		createdFrom: dateToString(new Date(null), "yyyy-MM-dd"),
		createdTo: dateToString(new Date(), "yyyy-MM-dd"),
		investStatus: searchElement.statusSearch ? searchElement.statusSearch : [],
	});
	const [totalPage, setTotalPage] = useState(1);
	const [totalCount, setTotalCount] = useState(0);
	const [applyList, setApplyList] = useState([]);
	const [applyDetail, setApplyDetail] = useState({});
	const [judgeList, setJudgeList] = useState(null);
	const [settingList, setSettingList] = useState(null);
	const [judgeDetail, setJudgeDetail] = useState(null);
	const [judgeResultList, setJudgeResultList] = useState([]);
	const [judgeName, setJudgeName] = useState("");
	const [selected, setSelected] = useState("");

	const [applyInfoModal, setApplyInfoModal] = useState(false);
	const [itemSettingModal, setItemSettingModal] = useState(false);
	const itemSettingForm = useForm();
	const [judgeAssignModal, setJudgeAssignModal] = useState(false);
	// 참여한 심사목록
	const [participantJudgeList, setParticipantJudgeList] = useState([]);
	const [participantJudgeModal, setParticipantJudgeModal] = useState(false);

	// 심사마감 모달
	const [showCloseAlert, CloseAlert] = useAlert();
	const [showConfirmAlert, ConfirmAlert] = useAlert();

	const [resultModal, setResultModal] = useState(false);
	const [ModalTab, setModalTab] = useState("");
	const [checked, setChecked] = useState([]);
	const [dateReadOnly, setDateReadOnly] = useState(true);
	const [showDeleteAlert, DeleteAlert] = useAlert();
	const applyEndRequest = useRequest("delete", "vc/apply");
	const judgeListRequest = useRequest("post", "vc/apply/judge/search");
	const saveJudgeListRequest = useRequest("post", "/vc/apply/judge");
	const listDetailRequest = useRequest("get", "vc/apply");
	const detailRequest = useRequest("post", "/vc/apply/setting/search");
	const saveSettingRequest = useRequest("post", "vc/apply/review");

	const [currentTab, setCurrentTab] = useState("전체");

	// 2중모달 추가부분
	const [noCategoryAlert, setNoCategoryAlert] = useState(false);
	const [weightingAlert, setWeightingAlert] = useState(false);
	const [noEvaluationAlert, setNoEvaluationAlert] = useState(false);
	const [noTitleAlert, setNoTitleAlert] = useState(false);
	const [noCategoryName, setNoCategoryName] = useState(false);
	const [noItemName, setNoItemName] = useState(false);
	const [settingDetail, setSettingDetail] = useState({});
	const [resetItemData, setResetData] = useState("");
	const [targetIdx, setTargetIdx] = useState("");
	const [createNew, setCreateNew] = useState("create");
	const [roundItemModal, setRoundItemModal] = useState(false);
	const [isSelect, setIsSelect] = useState(false)

	const settingCreateRequest = useRequest("post", "/vc/invest/setting/add");
	const settingModifyRequest = useRequest("post", "/vc/invest/setting/edit");
	// 심사마감
	const applyCloseRequest = useRequest("post", `/vc/apply/close`);

	const handleModify = (modiFormData) => {
		settingModifyRequest.call(modiFormData);
	};
	const handleNewCreation = (createFormData) => {
		settingCreateRequest.call(createFormData);
	};

	// 2중모달 추가부분

	const onChangeName = (e) => {
		setJudgeName(e.target.value);
	};

	const handleJudgeSearch = () => {
		judgeListRequest.call({ page: 1, size: 1000, queryType: "NAME", query: judgeName });
	};

	const tabMenuList = [
		{ id: "전체", title: t("constant.ReviewStatusConstant.all") },
		{ id: "심사대기", title: t("constant.ReviewStatusConstant.wait") },
		{ id: "심사중", title: t("constant.ReviewStatusConstant.review") },
		{ id: "심사완료", title: t("constant.ReviewStatusConstant.complete") },
	];

	const saveSetting = () => {
		saveSettingRequest.call({
			applyIdx: parseInt(applyDetail.idx),
			settingIdx: selected.idx,
		});
		setItemSettingModal(false);
	};

	const getDetailModal = (idx, type, data=null) => {
		setTargetIdx(idx)
		const detail = applyList.find((d) => d.idx === idx);
		setApplyDetail(detail);

		if (type === "info") {
			setApplyInfoModal(true);
		} else if (type === "setting") {
			detailRequest.call({
				page: 1,
				size: 1000,
				applyIdx: parseInt(idx),
			});
		} else if (type === "judge") {
			if (detail?.judges && detail?.judges.length > 0) {
				detail?.judges.map((item) => {
					checked.push(item.user.idx);
				});
			}
			setJudgeAssignModal(true);
		} else if (type === "participantJudge") {
			setParticipantJudgeModal(true);
			setParticipantJudgeList(data);
		} else if (type === "result") {
			listDetailRequest.call(idx, "path");
		} else if (type === "close") {
			showCloseAlert().then(() => applyCloseRequest.call(idx, "path"));
		}
	};

	// 심사종료
	useEffect(() => {
		switch (applyCloseRequest.state) {
			case API_STATE.done:
				showConfirmAlert().then(() => listRequest.call(formData))
				break;
			default:
				break;
		}
	}, [applyCloseRequest.state, applyCloseRequest.response]);


	useEffect(() => {
		switch (listDetailRequest.state) {
			case API_STATE.done:
				const requestApplyDetailList = listDetailRequest.response?.data;
				setJudgeDetail(requestApplyDetailList);
				const maketabList = requestApplyDetailList?.apply?.judges?.map((list) => {
					return {
						id: list.user.id,
						title: list.user.name,
					};
				});
				setModalTab(maketabList[0]?.id);
				setJudgeResultList(maketabList);
				setResultModal(true);
				break;
			default:
				break;
		}
	}, [listDetailRequest.state, listDetailRequest.response]);

	useEffect(() => {
		switch (detailRequest.state) {
			case API_STATE.done:
				const requestSettingList = detailRequest.response?.data;
				setSettingList(requestSettingList.settings);
				const getDefualted = requestSettingList.settings.filter((list) => list.isSelected);
				if (getDefualted && getDefualted.length > 0) {
					setSelected(getDefualted[0]);
				}
				setItemSettingModal(true);
				break;
			default:
				break;
		}
	}, [detailRequest.state, detailRequest.response]);

	useEffect(() => {
		switch (settingCreateRequest.state) {
			case API_STATE.done:
				// let res = settingCreateRequest.response;
				// setSelectValue({
				// 	label: res.title, value: res.idx
				// })
				setRoundItemModal(false);
				detailRequest.call({
					page: 1,
					size: 1000,
					applyIdx: parseInt(targetIdx),
				});
				setIsSelect(true)
				break;
			case API_STATE.error:
				console.log("settingCreateRequest error !!! >> ", settingCreateRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [settingCreateRequest.state, settingCreateRequest.response, settingCreateRequest.error]);



	const saveJudgeList = () => {
		let tmpForm = [];
		checked.map((item) => {
			tmpForm.push({
				userIdx: item,
				role: "심사참여",
			});
		});
		saveJudgeListRequest.call({
			applyIdx: parseInt(applyDetail.idx),
			judges: tmpForm,
		});
	};

	const deleteApply = (idx) => {
		showDeleteAlert().then(async () => {
			await applyEndRequest.call(idx, "path");
			await window.location.reload();
		});
	};

	useEffect(() => {
		if (currentTab === "전체") {
			setFormData({ ...formData, investStatus: [], page: 1 });
		} else {
			setFormData({ ...formData, investStatus: [currentTab], page: 1 });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTab]);

	useEffect(() => {
		judgeListRequest.call({ page: 1, size: 1000 });
	}, []);

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestApplyList = listRequest.response?.data;
				setTotalPage(requestApplyList.pagination.totalPage);
				setTotalCount(requestApplyList.pagination.totalCount);
				setApplyList(requestApplyList.applies);
				setLoadingPage(false);
				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	useEffect(() => {
		listRequest.call(formData);
	}, [formData]);

	useEffect(() => {
		switch (saveJudgeListRequest.state) {
			case API_STATE.done:
				setJudgeAssignModal(false);
				setLoadingPage(true);
				listRequest.call(formData);
				break;
			default:
				break;
		}
	}, [saveJudgeListRequest.state, saveJudgeListRequest.response]);

	useLayoutEffect(() => {
		switch (judgeListRequest.state) {
			case API_STATE.done:
				const judgeListRequestList = judgeListRequest.response?.data;
				setJudgeList(judgeListRequestList.judges);

				break;
			default:
				break;
		}
	}, [judgeListRequest.state, judgeListRequest.response]);

	useEffect(() => {
		setFormData({
			...formData,
			page: 1,
			size: 10,
			investLevels: searchElement.scaleSearch ? searchElement.scaleSearch : [],
			industryFields: searchElement.indSearch ? searchElement.indSearch : [],
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchElement]);

	useEffect(() => {
		if (!judgeAssignModal) {
			setChecked([]);
		}
	}, [judgeAssignModal]);

	useEffect(() => {
		switch (searchRequest.state) {
			case API_STATE.done:
				const requestApplyList = searchRequest.response?.data;
				setTotalCount(requestApplyList.pagination.totalCount);
				setTotalPage(requestApplyList.pagination.totalPage);
				setApplyList(requestApplyList.applies);
				break;
			case API_STATE.error:
				console.log("error");
				break;
			default:
				break;
		}
	}, [searchRequest.state]);

	const handleSubmit = (data) => {
		const submitData = {
			...formData,
			...data,
			page: 1,
		};

		setFormData(submitData);
		searchRequest.call(submitData);
	};

	const onApplysubmit = (d) => {
		const submitData = {
			createdFrom: dateToString(d?.createdFrom, "yyyy-MM-dd"),
			createdTo: dateToString(d?.createdTo, "yyyy-MM-dd"),
			companyName: d.companyName,
		};

		handleSubmit(submitData);
	};

	const formDate = applyListForm.watch("dateType");

	const dateTypeOptions = [
		{ label: "전체", value: "1" },
		{ label: "3개월", value: "2" },
		{ label: "6개월", value: "3" },
		{ label: "12개월", value: "4" },
		{ label: "직접입력", value: "5" },
	];

	const clickDateType = (e) => {
		const selectedDate = e.target.value;

		if (formDate === selectedDate) {
			applyListForm.setValue("dateType", "");
		} else {
			const currentDate = new Date();
			let createdFrom = "";
			let createdTo = "";

			switch (selectedDate) {
				case "1":
					createdFrom = new Date(null);
					createdTo = currentDate;
					setDateReadOnly(true);
					setFormData({ ...formData, createdFrom: createdFrom, createdTo: createdTo });
					break;
				case "2":
					const threeMonthAgo = new Date(currentDate);
					threeMonthAgo.setMonth(currentDate.getMonth() - 3);
					createdFrom = threeMonthAgo;
					createdTo = currentDate;
					setDateReadOnly(true);
					setFormData({ ...formData, createdFrom: createdFrom, createdTo: createdTo });
					break;
				case "3":
					const sixMonthAgo = new Date(currentDate);
					sixMonthAgo.setMonth(currentDate.getMonth() - 6);
					createdFrom = sixMonthAgo;
					createdTo = currentDate;
					setDateReadOnly(true);
					setFormData({ ...formData, createdFrom: createdFrom, createdTo: createdTo });
					break;
				case "4":
					const oneYearAgo = new Date(currentDate);
					oneYearAgo.setFullYear(currentDate.getFullYear() - 1);
					createdFrom = oneYearAgo;
					createdTo = currentDate;
					setDateReadOnly(true);
					setFormData({ ...formData, createdFrom: createdFrom, createdTo: createdTo });
					break;
				case "5":
					createdFrom = currentDate;
					createdTo = currentDate;
					setDateReadOnly(false);
					break;
				default:
					break;
			}

			applyListForm.setValue("createdFrom", createdFrom);
			applyListForm.setValue("createdTo", createdTo);
		}
	};

	return (
		<>
			<NavbarAndSidebarLayout menu={["apply", "management"]} type={"main"}>
				<If condition={loadingPage}>
					<Case condition={true}>
						<LoadingPage />
					</Case>
					<OtherWise>
						<PageHeader />
						<TabMenu
							tabItem={tabMenuList}
							currentTab={currentTab}
							setCurrentTab={setCurrentTab}
						/>
						<div className="c__card search-wrap-card">
							<Form useForm={applyListForm}>
								<Group label="신청기간" className="datePicker-group">
									<Radio
										name="dateType"
										options={dateTypeOptions}
										handleClick={clickDateType}
										className="c__switch"
									/>
									<DatePicker
										name="createdFrom"
										readonly={dateReadOnly}
										onChange={(date) => {
											setFormData({ ...formData, createdFrom: date });
										}}
									/>
									<span className="dash"> - </span>
									<DatePicker
										name="createdTo"
										readonly={dateReadOnly}
										onChange={(date) => {
											setFormData({ ...formData, createdTo: date });
										}}
									/>
								</Group>
								<Group label="기업이름" className="round-title-wrap">
									<Input
										name="companyName"
										placeholder="기업명을 입력해주세요."
										onEnter={applyListForm.handleSubmit(onApplysubmit)}
									/>
									<button
										color="primary"
										className="btn__solid angled btn-search"
										onClick={applyListForm.handleSubmit(onApplysubmit)}
									>
										검색
									</button>
								</Group>
							</Form>
						</div>
						{applyList.length !== 0 ? (
							<div className="c__card apply-management-content">
								<ul className="apply-management-list">
									<ApplyMangeListTable
										{...{
											setItemSettingModal,
											setJudgeAssignModal,
											setResultModal,
											showDeleteAlert,
											applyList,
											getDetailModal,
											deleteApply,
											loadingPage,
											currentTab,
											formData,
											totalCount,
										}}
									/>
								</ul>
								<Pagination
									currentPage={formData.page}
									totalPage={totalPage}
									setPageNumber={(number) => {
										if (typeof number === "number")
											return setFormData((prev) => ({
												...prev,
												page: number,
											}));
										setFormData((prev) => ({
											...prev,
											page: number(prev.page),
										}));
									}}
								/>
							</div>
						) : (
							<div className="c__noData">
								<CautionIcon />
								<p className="main">
									{t(
										"pages.apply.ApplyManage.applyMangeListTable.noApplyMessage"
									)}
								</p>
							</div>
						)}
					</OtherWise>
				</If>
				<div ref={containerRef} />
			</NavbarAndSidebarLayout>
			{/*---- 지원내용 모달*/}
			<ApplyDetailModal
				applyDetail={applyDetail}
				applyInfoModal={applyInfoModal}
				setApplyInfoModal={setApplyInfoModal}
			/>
			{/*---- 심사항목설정(수정) 모달*/}
			<ApplyItemSetting
				saveSetting={saveSetting}
				selected={selected}
				setSelected={setSelected}
				settingList={settingList}
				applyDetail={applyDetail}
				itemSettingModal={itemSettingModal}
				setItemSettingModal={setItemSettingModal}
				itemSettingForm={itemSettingForm}
				setRoundItemModal={setRoundItemModal}
				autoSelectNewOption={isSelect}
			/>
			{/*---- 심사역배정(수정) 모달*/}
			<ModalTemplate
				title={t("pages.apply.ApplyManage.Modal.JudgeListModal.setJudge")}
				modalState={judgeAssignModal}
				setModalToggle={setJudgeAssignModal}
				width={680}
				className="getTeamInfo-modal judge-assign-modal"
			>
				<JudgeListModal
					handleJudgeSearch={handleJudgeSearch}
					onChangeName={onChangeName}
					judgeAssignModal={judgeAssignModal}
					setJudgeAssignModal={setJudgeAssignModal}
					judgeList={judgeList}
					checked={checked}
					setChecked={setChecked}
					saveJudgeList={saveJudgeList}
					judgeListRequest={judgeListRequest}
					type={"view"}
				/>
			</ModalTemplate>
			{/*---- 참가한 심사역목록 모달*/}
			<ModalTemplate
				title={"심사역"}
				modalState={participantJudgeModal}
				setModalToggle={setParticipantJudgeModal}
				width={680}
				className="getTeamInfo-modal judge-assign-modal"
			>
				<JudgeParticipants
					onChangeName={onChangeName}
					participantJudgeModal={participantJudgeModal}
					setParticipantJudgeModal={setParticipantJudgeModal}
					judgeList={participantJudgeList}
					type={"view"}
				/>
			</ModalTemplate>
			{/*----- 심사결과 모달*/}
			<JudgeResultModal
				{...{
					judgeDetail,
					applyDetail,
					resultModal,
					setResultModal,
					judgeResultList,
					ModalTab,
					setModalTab,
				}}
			/>
			<Processing
				{...{
					settingDetail,
					setSettingDetail,
					createNew,
					roundItemModal,
					setRoundItemModal,
					setNoCategoryAlert,
					setWeightingAlert,
					setNoEvaluationAlert,
					setNoTitleAlert,
					resetItemData,
					setResetData,
					setNoCategoryName,
					setNoItemName,
					handleModify,
					handleNewCreation,
					targetIdx,
				}}
			/>

			{/*---- 지원삭제*/}
			<DeleteAlert
				type="warning"
				message={t("pages.apply.ApplyManage.Modal.warning")}
				reject={t("pages.vcInfo.VcMember.non")}
				confirm={t("pages.vcInfo.VcMember.yes")}
			/>

			{/*---- 심사마감*/}
			<CloseAlert
				type="warning"
				message={"심사를 종료하시겠습니까?"}
				subMessage={"심사가 완료되면  더 이상 심사할 수 없습니다."}
				reject={t("pages.round.RoundReg.container.RoundRegContainer.no")}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.yes")}
			/>
			<ConfirmAlert
				type="success"
				message={"심사가 완료되었습니다."}
				confirm={t("pages.round.RoundReg.container.RoundRegContainer.yes")}
			/>
		</>
	);
};

export default ApplyManage;
